// extracted by mini-css-extract-plugin
module.exports = {"mountainBackground":"NewBrief_mountainBackground__bob_E","headerMountainBackground":"NewBrief_headerMountainBackground__hSt0o"};